import { AbstractContentState, useCmsContent } from '@cp-shared-19/frontend-integration';
import { NavigationBar } from 'cpnl-common';
import { fetchNavigationBar } from './NavigationBarSlice';
import { NavigationBarContentSelector } from './NavigationBarContentSelector';

export function useNavigationBar(): AbstractContentState<NavigationBar> {
    return useCmsContent(fetchNavigationBar, NavigationBarContentSelector);
}
